const ProductTypeCategory = Object.freeze({

    TEST: 'test',
    CONSULT: 'consult',
    TREATMENT: 'treatment',
    SUPPLEMENT: 'supplement',
    MEDICATION: 'medication',
    BUNDLE: 'bundle'
})


export default ProductTypeCategory;
